import type { FingerType } from "./types";

export type CaptureMode = "single-finger" | "four-fingers";

export interface CaptureGuide {
  left: number;
  top: number;
  width: number;
  height: number;
}

const CAPTURE_GUIDES: Record<CaptureMode, Readonly<CaptureGuide>> = {
  "single-finger": {
    left: 0.24,
    top: 0.29,
    width: 0.52,
    height: 0.42,
  },
  "four-fingers": {
    left: 0.08,
    top: 0.2,
    width: 0.84,
    height: 0.6,
  },
};

export function isFourFingerCapture(finger: FingerType): boolean {
  return finger === "left_four_fingers" || finger === "right_four_fingers";
}

export function captureModeFor(finger: FingerType): CaptureMode {
  return isFourFingerCapture(finger) ? "four-fingers" : "single-finger";
}

export function captureGuideFor(
  captureMode: CaptureMode,
): Readonly<CaptureGuide> {
  return CAPTURE_GUIDES[captureMode];
}

export function captureHandFor(
  finger: FingerType,
): "left" | "right" | undefined {
  if (finger === "left_four_fingers") return "left";
  if (finger === "right_four_fingers") return "right";
  return undefined;
}

export function captureTargetName(finger: FingerType): string | undefined {
  if (finger === "unspecified") return undefined;
  return finger.replaceAll("_", " ");
}
